import React from 'react';
import BaseClass from '@/pages/BaseClass';
import CompanyProfile from '@/components/CompanyProfile';

import $ from 'jquery';
import {
	Form,
	Table,
	Button,
	Input,
	InputNumber,
	Radio,
	Cascader,
	Upload,
	Image,
} from 'antd'
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	httpPost
} from '@/utils/Tools';

const {Column,ColumnGroup} = Table;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'userInfo':{},
			'validateTimer':0,
			'rules':{
				'user_name':[
					{
						required: true,
						message: '请输入手机号',
					},
					{
						pattern: /^1\d\d\d{8}$/,
						message: '请输入正确的手机号',
					},
					/*
					{
						validator: (rule,value)=>{
							if(value != this.state.userInfo['user_name'])
								return Promise.reject(new Error('手机号输入错误'));
							else 
								return Promise.resolve();
						},
					},
					*/
				],
				'validate_code':[
					{
						required: true,
						message: '请输入验证码',
					},
				],
				'password':[
					{
						required: true,
						message: '请输入新密码',
					},
				],
				'password1':[
					{
						required: true,
						message: '请确认密码',
					},
					{
						validator: (rule,value)=>{
							if(value != this.mainForm.getFieldValue('password'))
								return Promise.reject(new Error('两次密码输入不一致'));
							else 
								return Promise.resolve();
						},
					},
				],
			},
		};
	}
	
	componentDidMount()
	{
		let userInfo = CommonValue.get('user_info');
		this.setState({
			'userInfo':userInfo,
		});
		document.title = '修改资料 - ' + CommonValue.get('site_name');
	}
	
	//发送验证码
	sendValidate()
	{
		this.mainForm.validateFields(['user_name'])
			.then((info)=>{
				if(info['user_name'] != this.state.userInfo['user_name'])
				{
					message('手机号错误');
					return false;
				}
				
				let phone = info['user_name'];
				let url = pcUrl('index','sendValidate');
				let param = {
					'phone':phone,
					'is_register':0,
				};
				httpPost(url,param)
					.then(()=>{
						message('验证码已发送','success');
						this.setState({
							'validateTimer':10,
						});
						let loop = window.setInterval(()=>{
							let timer = this.state.validateTimer;
							if(--timer == 0)
								window.clearInterval(loop);
							
							this.setState({
								'validateTimer':timer,
							});
						},1000);
					});
			});
	}
	
	submit(info)
	{
		let url = pcUrl('user','changePassword');
		let param = info;
		httpPost(url,param)
			.then(()=>{
				message('密码已被重置，请重新登录','success',1)
					.then(()=>{
						this.logout();
					});
				//window.location.href = ngUrl('login');
			});
	}
	
	logout()
	{
		let url = pcUrl('index','logout');
		httpPost(url)
			.then(()=>{
				CommonValue.set('user_info','');
				this.setState({
					'userInfo':{},
				});
				window.location.href = ngUrl('login');
			});
	}
	
	render()
	{
		return (
			<div>
				
				{+this.state.userInfo['is_manager'] ? (
				<CompanyProfile />
				):''}
				<div className="user-panel">
					<div className="captain">
						<h3>修改密码</h3>
					</div>
					<div className="panel-body">
						<div className="">
							<Form
								ref={e=>this.mainForm = e}
								labelCol={{ span:3 }}
								onFinish={(data)=>this.submit(data)}
								onFinishFailed={data=>this.focusError(data)}
								wrapperCol={{ span:10 }}>
								<Form.Item label="手机号" name="user_name" rules={this.state.rules['user_name']}>
									<Input  />
								</Form.Item>
								<Form.Item label="验证码" name="validate_code" rules={this.state.rules['validate_code']}>
									<Input.Group>
										<Input style={{'width':'70%'}} onChange={e=>this.mainForm.setFieldsValue({'validate_code':e.target.value})} />
										&nbsp;&nbsp;
										<Button disabled={this.state.validateTimer !== 0} style={{'width':'27%'}} onClick={()=>this.sendValidate()}>
											{this.state.validateTimer ? '剩余'+this.state.validateTimer+'秒' : '获取验证码'}
										</Button>
									</Input.Group>
								</Form.Item>
								<Form.Item label="新密码" name="password" rules={this.state.rules['password']}>
									<Input.Password />
								</Form.Item>
								<Form.Item label="确认密码" name="password1" rules={this.state.rules['password1']}>
									<Input.Password />
								</Form.Item>
								<Form.Item wrapperCol={{ offset:3 }}>
									<Button type="primary" htmlType="submit">确认</Button>
								</Form.Item>
							</Form>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

